function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17 21h-6.72c-1.62 0-3.17-.69-4.25-1.88L2.5 15.24a4.783 4.783 0 010-6.47l3.53-3.88A5.727 5.727 0 0110.28 3H17c3.17 0 5.75 2.58 5.75 5.75v6.5c0 3.17-2.58 5.75-5.75 5.75zM10.28 4.5c-1.19 0-2.34.51-3.14 1.39L3.6 9.78a3.301 3.301 0 000 4.45l3.53 3.88c.8.88 1.95 1.39 3.14 1.39H17a4.26 4.26 0 004.25-4.25v-6.5A4.26 4.26 0 0017 4.5h-6.72z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 15.22c-.19 0-.38-.07-.53-.22l-4.94-4.95a.754.754 0 010-1.06c.29-.29.77-.29 1.06 0l4.94 4.95c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.06 15.22c-.19 0-.38-.07-.53-.22a.754.754 0 010-1.06L15.47 9c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L11.59 15c-.15.15-.34.22-.53.22z"
})));